import { ReactNode } from 'react';
import { css } from '@linaria/atomic';
import { NoAccessEmptyState as NoAccessEmptyStateSvg } from '@frontend/empty-states#svg';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';

const noAccessEmptyStateNoAccessEmptyStateSvgStyle3 = css`
  width: 375px;
  height: 375px;
`;

const noAccessEmptyStateTextStyle4 = css`
  color: ${theme.colors.neutral50};
  padding: ${theme.spacing(0, 1.5)};
`;

type NoAccessEmptyStateProps = {
  message?: ReactNode;
};

/**
 * For pages with no acl access
 */
export const NoAccessEmptyState: React.FC<NoAccessEmptyStateProps> = ({ message }) => {
  return (
    <div className={containerStyle}>
      <div className={contentStyle}>
        <NoAccessEmptyStateSvg className={noAccessEmptyStateNoAccessEmptyStateSvgStyle3} />
        {message && (
          <Text textAlign='center' className={noAccessEmptyStateTextStyle4}>
            {message}
          </Text>
        )}
      </div>
    </div>
  );
};

const containerStyle = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const contentStyle = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: ${theme.spacing(4)};
`;
